export default __webpack_public_path__ + "static/media/5.2a5f159f.png";